// iranLocations.js
export const iranLocations = [
  {
    name: "آذربایجان شرقی",
    cities: [
      "تبریز",
      "مراغه",
      "مرند",
      "میانه",
      "اهر",
      "بناب",
      "اسکو",
      "شبستر",
      "عجب‌شیر",
      "آذرشهر",
      "سراب",
      "ملکان",
      "ورزقان",
      "کلیبر",
      "جلفا",
      "هریس",
      "هشترود",
      "چاراویماق",
      "خداآفرین",
      "هوراند",
    ],
  },
  {
    name: "آذربایجان غربی",
    cities: [
      "ارومیه",
      "خوی",
      "میاندوآب",
      "مهاباد",
      "بوکان",
      "سلماس",
      "پیرانشهر",
      "نقده",
      "سردشت",
      "تکاب",
      "شاهین‌دژ",
      "اشنویه",
      "چالدران",
      "پلدشت",
      "چایپاره",
      "شوظت",
      "باروق",
      "چهاربرج",
    ],
  },
  {
    name: "اردبیل",
    cities: [
      "اردبیل",
      "پارس‌آباد",
      "مشگین‌شهر",
      "خلخال",
      "گرمی",
      "نمین",
      "بیله‌سوار",
      "کوثر",
      "سرعین",
      "نیر",
      "اصلاندوز",
      "انگوت",
    ],
  },
  {
    name: "اصفهان",
    cities: [
      "اصفهان",
      "کاشان",
      "خمینی‌شهر",
      "نجف‌آباد",
      "شاهین‌شهر",
      "شهرضا",
      "فولادشهر",
      "تیران",
      "مبارکه",
      "آران و بیدگل",
      "زرین‌شهر",
      "گلپایگان",
      "فریدن",
      "فریدون‌شهر",
      "فلاورجان",
      "نایین",
      "نطنز",
      "اردستان",
      "سمیرم",
      "خوانسار",
      "دهاقان",
      "چادگان",
      "خور و بیابانک",
      "هرند",
      "جرقویه",
      "ورزنه",
    ],
  },
  {
    name: "البرز",
    cities: [
      "کرج",
      "فردیس",
      "کمال‌شهر",
      "نظرآباد",
      "محمدشهر",
      "ماهدشت",
      "مشکین‌دشت",
      "هشتگرد",
      "چهارباغ",
      "اشتهارد",
      "طالقان",
      "گلسار",
      "کوهسار",
      "آسارا",
    ],
  },
  {
    name: "ایلام",
    cities: [
      "ایلام",
      "دهلران",
      "ایوان",
      "آبدانان",
      "چرداول",
      "مهران",
      "دره‌شهر",
      "بدره",
      "ایوان",
      "ملکشاهی",
      "سیروان",
      "هلیلان",
      "چوار",
    ],
  },
  {
    name: "بوشهر",
    cities: [
      "بوشهر",
      "برازجان",
      "بندر گناوه",
      "بندر کنگان",
      "خورموج",
      "عسلویه",
      "بندر دیلم",
      "جم",
      "بندر دیر",
      "اهرم",
      "چغادک",
      "سیراف",
      "عالیشهر",
      "شبانکاره",
    ],
  },
  {
    name: "تهران",
    cities: [
      "تهران",
      "شهریار",
      "اسلامشهر",
      "قدس",
      "ملارد",
      "صباپایانه",
      "پاکدشت",
      "ری",
      "پردیس",
      "دماوند",
      "ورامین",
      "قرچک",
      "نسیم‌شهر",
      "اندیشه",
      "رباط‌کریم",
      "بومهن",
      "فشم",
      "لواسان",
      "آبسرد",
      "پیشوا",
      "فیروزکوه",
      "چهاردانگه",
      "حسن‌آباد",
    ],
  },
  {
    name: "چهارمحال و بختیاری",
    cities: [
      "شهرکرد",
      "بروجن",
      "لردگان",
      "فرخ‌شهر",
      "فارسان",
      "هفشجان",
      "کیار",
      "سامان",
      "بن",
      "اردل",
      "کوهرنگ",
      "خانمیرزا",
      "فلارد",
    ],
  },
  {
    name: "خراسان جنوبی",
    cities: [
      "بیرجند",
      "قائن",
      "طبس",
      "فردوس",
      "نهبندان",
      "بشرویه",
      "سرايان",
      "سربیشه",
      "درمیان",
      "زیرکوه",
      "خوسف",
    ],
  },
  {
    name: "خراسان رضوی",
    cities: [
      "مشهد",
      "نیشابور",
      "سبزوار",
      "تربت حیدریه",
      "قوچان",
      "گناباد",
      "کاشمر",
      "تربت جام",
      "تایباد",
      "چناران",
      "سرخس",
      "درگز",
      "فریمان",
      "خواف",
      "بردسکن",
      "طرقبه",
      "شاندیز",
      "جوین",
      "جغتای",
      "زاوه",
      "رشتخوار",
      "مهولات",
      "بجستان",
      "صالح‌آباد",
      "زبرخان",
      "گلبهار",
    ],
  },
  {
    name: "خراسان شمالی",
    cities: [
      "بجنورد",
      "شیروان",
      "اسفراین",
      "آشخانه",
      "جاجرم",
      "فاروج",
      "گرمه",
      "راز و جرگلان",
      "مانه و سملقان",
    ],
  },
  {
    name: "خوزستان",
    cities: [
      "اهواز",
      "دزفول",
      "آبادان",
      "بندر ماهشهر",
      "خرمشهر",
      "اندیمشک",
      "ایذه",
      "شوشتر",
      "شوش",
      "بهبهان",
      "رامهرمز",
      "مسجدسلیمان",
      "امیدیه",
      "شادگان",
      "دشت آزادگان",
      "هویزه",
      "باغ‌ملک",
      "گتوند",
      "رامشیر",
      "هندیجان",
      "کارون",
      "باوی",
      "کرخه",
      "دزپارت",
    ],
  },
  {
    name: "زنجان",
    cities: [
      "زنجان",
      "ابهر",
      "خرمدره",
      "قیدار",
      "طارم",
      "ماهنشان",
      "ایجرود",
      "سلطانیه",
    ],
  },
  {
    name: "سمنان",
    cities: [
      "سمنان",
      "شاهرود",
      "دامغان",
      "گرمسار",
      "مهدی‌شهر",
      "سرخه",
      "میامی",
      "آرادان",
    ],
  },
  {
    name: "سیستان و بلوچستان",
    cities: [
      "زاهدان",
      "چابهار",
      "زابل",
      "ایرانشهر",
      "سراوان",
      "خاش",
      "کنارک",
      "جالق",
      "راسک",
      "نیک‌شهر",
      "زهک",
      "میرجاوه",
      "دشتیاری",
      "تفتان",
      "فنوج",
      "قصرقند",
      "نیمروز",
      "هامون",
      "سیب و سوران",
      "مهرستان",
    ],
  },
  {
    name: "فارس",
    cities: [
      "شیراز",
      "مرودشت",
      "جهرم",
      "فسا",
      "کازرون",
      "لارستان",
      "داراب",
      "آباده",
      "نورآباد",
      "اقلید",
      "استهبان",
      "نی‌ریز",
      "گراش",
      "لامرد",
      "کوار",
      "زرقان",
      "سپیدان",
      "فیروزآباد",
      "زرین‌دشت",
      "خرم‌بید",
      "بوانات",
      "سروستان",
      "ارژن",
      "مهر",
      "بیضا",
      "سرچهان",
      "خفر",
    ],
  },
  {
    name: "قزوین",
    cities: [
      "قزوین",
      "تاکستان",
      "الوند",
      "اقبالیه",
      "آبیک",
      "محمدیه",
      "بوئین‌زهرا",
      "شال",
      "آوج",
      "مهرگان",
    ],
  },
  {
    name: "قم",
    cities: ["قم", "جعفریه", "کهک", "قنوات", "سلفچگان", "دستجرد"],
  },
  {
    name: "کردستان",
    cities: [
      "سنندج",
      "سقز",
      "مریوان",
      "بانه",
      "قروه",
      "کامیاران",
      "بیجار",
      "دیواندره",
      "دهگلان",
      "سروآباد",
    ],
  },
  {
    name: "کرمان",
    cities: [
      "کرمان",
      "سیرجان",
      "رفسنجان",
      "جیرفت",
      "بم",
      "زرند",
      "کهنوج",
      "شهربابک",
      "بفت",
      "بردسیر",
      "عنبرآباد",
      "منوجان",
      "راور",
      "ارزوئیه",
      "انار",
      "رودبار جنوب",
      "فاریاب",
      "ریگان",
      "فهرج",
      "نرماشیر",
      "جازموریان",
    ],
  },
  {
    name: "کرمانشاه",
    cities: [
      "کرمانشاه",
      "اسلام‌آباد غرب",
      "جوانرود",
      "کنگاور",
      "سرپل ذهاب",
      "سنقر",
      "هرسین",
      "صحنه",
      "پاوه",
      "گیلانغرب",
      "روانسر",
      "قصر شیرین",
      "ثلاث باباجانی",
      "دالاهو",
    ],
  },
  {
    name: "کهگیلویه و بویراحمد",
    cities: [
      "یاسوج",
      "دوگنبدان",
      "دهدشت",
      "لیکک",
      "سی‌سخت",
      "چرام",
      "لنده",
      "باشت",
      "مارگون",
    ],
  },
  {
    name: "گلستان",
    cities: [
      "گرگان",
      "گنبد کاووس",
      "علی‌آباد کتول",
      "بندر ترکمن",
      "آق‌قلا",
      "آزادشهر",
      "کردکوی",
      "کلاله",
      "مینودشت",
      "گالیکش",
      "بندر گز",
      "مراوه‌تپه",
      "رامیان",
      "گمیشان",
    ],
  },
  {
    name: "گیلان",
    cities: [
      "رشت",
      "بندر انزلی",
      "لاهیجان",
      "لنگرود",
      "تالش",
      "آستارا",
      "صومعه‌سرا",
      "آستانه اشرفیه",
      "فومن",
      "رودسر",
      "رودبار",
      "رضوانشهر",
      "خمام",
      "ماسال",
      "شفت",
      "سیاهکل",
      "املش",
    ],
  },
  {
    name: "لرستان",
    cities: [
      "خرم‌آباد",
      "بروجرد",
      "دورود",
      "کوهدشت",
      "الیگودرز",
      "نورآباد",
      "الشتر",
      "پلدختر",
      "ازنا",
      "سراب دوره",
      "چگنی",
      "رومشکان",
    ],
  },
  {
    name: "مازندران",
    cities: [
      "ساری",
      "بابل",
      "آمل",
      "قائم‌شهر",
      "بهشهر",
      "چالوس",
      "نوشهر",
      "تنکابن",
      "بابلسر",
      "نکا",
      "رامسر",
      "محمودآباد",
      "جویبار",
      "نور",
      "سوادکوه",
      "فریدونکنار",
      "عباس‌آباد",
      "سوادکوه شمالی",
      "کلاردشت",
      "گلوگاه",
      "سیمرغ",
    ],
  },
  {
    name: "مرکزی",
    cities: [
      "اراک",
      "ساوه",
      "خمین",
      "محلات",
      "دلیجان",
      "شازند",
      "زرندیه",
      "تفرش",
      "کمیجان",
      "خنداب",
      "آشتیان",
      "فراهان",
    ],
  },
  {
    name: "هرمزگان",
    cities: [
      "بندرعباس",
      "میناب",
      "دهبارز",
      "قشم",
      "کیش",
      "بندر لنگه",
      "حاجی‌آباد",
      "بندر خمیر",
      "پارسیان",
      "جاسک",
      "بستک",
      "رودان",
      "سیریک",
      "بشکرد",
      "هرمز",
    ],
  },
  {
    name: "همدان",
    cities: [
      "همدان",
      "ملایر",
      "نهاوند",
      "تویسرکان",
      "اسدآباد",
      "کبوترآهنگ",
      "بهار",
      "رزن",
      "فامنین",
      "درگزین",
    ],
  },
  {
    name: "یزد",
    cities: [
      "یزد",
      "میبد",
      "اردکان",
      "بافق",
      "مهریز",
      "ابرکوه",
      "اشکذر",
      "تفت",
      "خاتم",
      "بهاباد",
      "مروست",
    ],
  },
];
